import React, { useState } from "react";
import PropTypes from "prop-types";
import FsLightbox from "fslightbox-react";
import * as theme2Styles from "../../scss/theme2.module.scss";

const Media = ({ pictures, watermark }) => {
  const [toggler, setToggler] = useState(false);
  const [slide, setSlide] = useState(0);

  const handleImageOnClick = (toggler, slide) => {
    setToggler(!toggler);
    setSlide(slide);
  };

  const sources = pictures.map((picture) =>
    watermark ? picture.watermark_url : picture.image_url
  );

  return (
    <div className={`${theme2Styles.detailsImagesC}`}>
      <FsLightbox
        type="image"
        toggler={toggler}
        slide={slide}
        sources={sources}
      />
      <div className={theme2Styles.detailsImages}>
        {pictures.slice(0, 1).map((picture, i) => {
          return (
            <div
              className={`${theme2Styles.thumbView}`}
              key={i}
              onClick={() => handleImageOnClick(toggler, i + 1)}
            >
              <img alt="image" src={picture.image_url} />
            </div>
          );
        })}
        <div className={theme2Styles.clear}></div>
      </div>
    </div>
  );
};

Media.propTypes = {
  pictures: PropTypes.array.isRequired,
  watermark: PropTypes.bool,
};

export default Media;
